// Stemmi dei club, indicizzati sul nome esatto della colonna `Squadra` del
// listone.
//
// Stavano dentro PlayerDisplay, e finche' li usava solo lui andava bene. Da
// quando anche il listone filtra per squadra con i loghi, due copie della
// stessa mappa sarebbero divergute alla prima promozione.
//
// L'elenco tiene anche le retrocesse (Cremonese, Pisa, Verona): costa un file
// in piu' in `public/logos/` e fa si' che una rosa importata da una stagione
// passata mostri comunque lo stemma invece di un buco.

const CLUBS = [
    'atalanta', 'bologna', 'cagliari', 'como', 'cremonese', 'fiorentina',
    'frosinone', 'genoa', 'inter', 'juventus', 'lazio', 'lecce', 'milan',
    'monza', 'napoli', 'parma', 'pisa', 'roma', 'sassuolo', 'torino',
    'udinese', 'venezia', 'verona',
];

export const TEAM_LOGOS = CLUBS.reduce((logos, club) => {
    logos[club.charAt(0).toUpperCase() + club.slice(1)] = `/logos/${club}.png`;
    return logos;
}, {});

/** Percorso dello stemma, oppure `null` per una squadra che non conosciamo. */
export function clubLogo(name) {
    return TEAM_LOGOS[name] ?? null;
}
